module.exports = __webpack_public_path__ + "img/eye.8a140553.svg";